exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aging-report-table[data-v-a836ea80]{width:100%;margin-top:4px}.aging-report-table>*[data-v-a836ea80]{width:100%}", ""]);

// exports
